import React, { Component } from "react";
import Breadcrumb from "../../../../shared/breadcrumb/Breadcrumb";
import { Card } from "../../../../components";

class CreateCampaningsPromoters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: null
      // nextCampaning: false,
    };
  }

  getName = value => {
    this.setState({
      name: value
    });
  };

  goDetail = () => {
    const { history } = this.props;
    const { name } = this.state;
    history.push(`/trade/campanhas/${name}`);
  };

  back = () => {
    const { history } = this.props;
    history.push("/");
  };

  render() {
    return (
      <div>
        <Breadcrumb
          crumb="Campanhas Promocionais"
          description="A realização de campanhas envolvendo sorteio de prêmios, distribuição gratuita de brindes, concursos, exige rigorosa observação às normas, além de estar de acordo com o que determina o Código de Defesa do Consumidor. Por isso é muito importante que você nos passe as informações abaixo, para estarmos dentro da legalidade e identificarmos a melhor campanha pra você."
        />
        <Card className="center-box box-padd">
          <div className="bx--row">
            <div className="bx--col-md-12">
              <h4 className="new-campaign-title">Criar Nova Campanha</h4>
              <h5 className="new-campaign-subtitle">
                Preencha um nome para sua campanha.
              </h5>
            </div>
          </div>
          <div className="bx--row ">
            <div className=" bx--col-xs-12 bx--col-md-8 mg-top-40">
              <label className="bx--label">Nome da Campanha</label>
              <input
                id="text-input-3"
                type="text"
                className="bx--text-input"
                placeholder="ex: engajamento"
                onChange={e => this.getName(e.target.value)}
              />
              <div className="bx--form-requirement">
                Nome da Campanha é obrigatório
              </div>
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-md-12  mg-top-40">
              <button
                onClick={() => this.goDetail()}
                className="bx--btn btn-secondary-color"
                type="submit"
              >
                Avançar
              </button>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

export default CreateCampaningsPromoters;



// WEBPACK FOOTER //
// ./src/screens/client/trades/campaings/CreateCampaningsPromoters.jsx